export default function (element, data) {
    const showMoreButton = element.querySelector(".show-more");
    const hideButton = element.querySelector(".hide");
    const questions = element.querySelectorAll(".faq-item");

    showMoreButton.addEventListener("click", showAll);
    hideButton.addEventListener("click", hide);

    function showAll() {
        showMoreButton.classList.remove("active");
        hideButton.classList.add("active");
        questions.forEach(faq => {
            faq.classList.remove("hidden");
        });
    }

    function hide() {
        showMoreButton.classList.add("active");
        hideButton.classList.remove("active");
        questions.forEach(faq => {
            if(faq.dataset.hidden == "true") {
                faq.classList.add("hidden");
            }
        });
    }
}
